export const validateInput = (value, regEx) => {
    if (value && regEx)
        return regEx.test(value);
}   

